import React from "react";
import { createRoot } from "react-dom/client";
import Search from "./Search";

let currentRoot = null;
let currentContainer = null;

const mobileQuery = window.matchMedia("(max-width: 767px)");

const desktopContainer = document.getElementById("search");
const searchText = desktopContainer ? desktopContainer.textContent.trim() : "Search...";

function getSearchContainer() {
  return mobileQuery.matches ? document.getElementById("search-mobile") : desktopContainer;
}

function renderSearch() {
  const container = getSearchContainer();
  if (container && container !== currentContainer) {
    if (currentRoot) {
      currentRoot.unmount();
    }
    // Always use the cached desktop value
    currentRoot = createRoot(container);
    currentRoot.render(<Search searchText={searchText} />);
    currentContainer = container;
  }
}

// Initial render
renderSearch();

// Re-render on media query change
mobileQuery.addEventListener("change", renderSearch);
